var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "d-block",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9049 3.32693L15.9039 3.32593L13.1659 0.587932C12.4249 -0.151068 11.1519 -0.186068 10.4499 0.518932L1.45387 9.51493C1.12787 9.83993 0.925873 10.2719 0.883873 10.7289L0.504873 14.8989C0.478873 15.1939 0.583873 15.4859 0.793873 15.6959C0.982873 15.8849 1.23787 15.9889 1.50087 15.9889C1.53187 15.9889 1.56187 15.9879 1.59187 15.9849L5.76187 15.6059C6.21987 15.5639 6.65087 15.3629 6.97587 15.0379L15.9729 6.04093C16.7009 5.31093 16.6699 4.09293 15.9049 3.32693Z",
    fill: "#0E8881"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/EditPencil.c3dba256f2732f9e68e6c54d1ca842c8.svg";
export { ForwardRef as ReactComponent };